class HeroImages {
    /**
     * constructor
     */
    constructor() {
        this.cacheDom();
        this.setImageSize();
    }

    cacheDom() {
        this.hero = document.querySelector('.c-hero');
        this.mobileString = 'mobile';
        this.tabletString = 'tablet';
        this.desktopString = 'desktop';
    }

    setImageSize() {
        if (_.isNull(this.hero) === false) {
            this.resize();
        }
    }
    
    resize() {
        if (_.isNull(this.hero) === false) {
            if (_.isUndefined(Breakpoint) === false) {
               
                if (Breakpoint.grpInt <= 3) {
                    this.showMobileImage();
                }

                if (Breakpoint.grpInt > 3 && Breakpoint.grpInt <= 7) {
                    this.showTabletImage();
                }

                if (Breakpoint.grpInt > 6) {
                    this.showDesktopImage();
                }
            }
        }
    }

    showDesktopImage() {
        if (this.elementHasImages(this.hero) && this.hero.getAttribute('data-current-img') !== this.desktopString) {
            this.loadImage(this.hero, this.hero.getAttribute('data-img-desktop'), this.desktopString);
        }
    }

    showTabletImage() {
        if (this.elementHasImages(this.hero) && this.hero.getAttribute('data-current-img') !== this.tabletString) {
            this.loadImage(this.hero, this.hero.getAttribute('data-img-tablet'), this.tabletString);
        }
    }

    showMobileImage() {
        if (this.elementHasImages(this.hero) && this.hero.getAttribute('data-current-img') !== this.mobileString) {
            this.loadImage(this.hero, this.hero.getAttribute('data-img-mobile'), this.mobileString);
        }
    }

    /**
     * loadImage()
     *
     * @param {Object} el
     * @param {String} newImg
     * @param {String} newString
     */
    loadImage(el, newImg, newString) {
        const img = new Image();
        // // Assign an onLoad handler to the dummy image *before* assigning the src
        img.onload = () => {
            el.style.backgroundImage = `url('${newImg}')`;
            el.setAttribute('data-current-img', newString);
        };
        // image its source.
        img.src = newImg;
    }

    elementHasImages(element) {
        return (element.getAttribute('data-img-desktop') !== null && element.getAttribute('data-img-tablet') !== null && element.getAttribute('data-img-mobile') !== null && element.getAttribute('data-current-img') !== null);
    }
}

module.exports = HeroImages;